const user = {
    isLoading: {
        basicInfo: false,
        supplierAddresses: false,
        wholesalerResellerList: false,
        addressList: false,
        postmenList: false,
        cartRuleList: false,
        picNumberList: false,
        creditCardList: false,
        referralCouponList: false,
        stripeFields: false,
        conversionRate: false,
        dispatchLocationList: false,
    },
    isReAuth: false,
    loggedIn: false,
    initialized: false,
    supplierInfo: {},

    info: {
        basicInfo: {},
        availableWholesalerReseller: [],
        availablePICNumbers: [],
        availableCreditCards: [],
        availableAddresses: [],
        availablePostmen: [],
        availableCartRules: [],
        availableReferralCoupons: [],
        availableDispatchLocations: [],
    },

    stripeFieldData: {},
    stripeConnectRequired: Number(window.isStripeConnectRequired) || 0,
    stripeConnectCompleted: Number(window.isStripeConnectComplete) || 0,

    type: 'retail-customer',
    productConfiguratorType: '',
    conversionRate: 0,
    orderOnBehalf: false,
    subStore: typeof window.subStore != 'undefined' ? window.subStore : false,
    subStoreDisplayPrice:
        typeof window.subStoreDisplayPrice != 'undefined'
            ? window.subStoreDisplayPrice
            : true,
};
const UserReducer = function (state = user, action) {
    switch (action.type) {
        case 'TOGGLE_USER_LOADING': {
            return {
                ...state,
                isLoading: {
                    ...state.isLoading,
                    [action.key]: action.value,
                },
            };
        }
        case 'SET_LOGGED_IN': {
            return {
                ...state,
                loggedIn: action.value,
            };
        }
        case 'SET_RE_AUTH': {
            return {
                ...state,
                isReAuth: action.value,
            };
        }
        case 'SET_USER_INITIALIZED': {
            return {
                ...state,
                initialized: action.value,
            };
        }
        case 'SET_MEMBER_TYPE': {
            return {
                ...state,
                type: action.value,
            };
        }
        case 'SET_MEMBER_PRODUCT_CONFIGURATOR_TYPE': {
            return {
                ...state,
                productConfiguratorType: action.value,
            };
        }
        case 'SET_ORDER_ON_BEHALF': {
            return {
                ...state,
                orderOnBehalf: action.value,
            };
        }
        case 'SET_CONVERSION_RATE': {
            return {
                ...state,
                conversionRate: action.value,
            };
        }
        case 'SET_USER_INFO': {
            let newInfo = {
                ...state.info,
                ...action.value,
            };

            const prevBasicInfo = state.info.basicInfo;
            if (prevBasicInfo !== undefined && prevBasicInfo) {
                newInfo.basicInfo = {
                    ...prevBasicInfo,
                    ...newInfo.basicInfo,
                };
            }

            return {
                ...state,
                info: newInfo,
            };
        }
        case 'SET_SUPPLIER_INFO': {
            return {
                ...state,
                supplierInfo: {
                    ...state.supplierInfo,
                    [action.id]: {
                        ...state.supplierInfo[action.id],
                        ...action.value,
                    },
                },
            };
        }
        case 'SET_USER_ADDRESSES': {
            return {
                ...state,
                addresses: action.value,
            };
        }
        case 'SET_STRIPE_FIELD_DATA': {
            return {
                ...state,
                stripeFieldData: {
                    ...state.stripeFieldData,
                    ...action.value
                },
            };
        }
        default: {
            return state;
        }
    }
};

export default UserReducer;
